module.exports = __webpack_public_path__ + "static/assets/8390bdcc14adcc0011c532272e3d3f69.jpg";